<template>
  <bottom-sheets :elevation="elevation" :z-index="zIndex" :color="color" :color-lightness="colorLightness" :bg-color="bgColor" :bg-color-lightness="bgColorLightness" :class="[baseCss]" v-model="visible" :rounded="rounded" :modal="false">
    <table-layout y-align="middle">
      <row>
        <cell :class="['p-1']" full-width>
          <slot />
        </cell>
        <cell v-if="cookiePolicyBtn" :class="['p-1']" x-align="center">
          <btn :width="btnWidth" :size="btnSize" :color="btnColor" :color-lightness="btnColorLightness" :bg-color="btnBgColor" :bg-color-lightness="btnBgColorLightness" @click="$emit('cookie-policy-btn-click')">{{ cookiePolicyBtnText }}</btn>
        </cell>
        <cell :class="['p-1']" x-align="center">
          <btn :width="btnWidth" :size="btnSize" :color="btnColor" :color-lightness="btnColorLightness" :bg-color="btnBgColor" :bg-color-lightness="btnBgColorLightness" @click="dismiss">{{ dismissBtnText }}</btn>
        </cell>
      </row>
    </table-layout>
  </bottom-sheets>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'CookieConsent',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('cookie-consent', [])
    }
  },
  model: {
    prop: 'visible',
    event: 'dismiss'
  },
  props: {
    visible: {
      type: Boolean
    },
    elevation: {
      type: String
    },
    btnBgColor: {
      type: String
    },
    btnBgColorLightness: {
      type: Number
    },
    btnColor: {
      type: String
    },
    btnWidth: {
      type: String,
      default: '64px'
    },
    btnSize: {
      type: String,
      default: 'sm'
    },
    btnColorLightness: {
      type: Number
    },
    color: {
      type: String
    },
    colorLightness: {
      type: Number
    },
    bgColor: {
      type: String,
      default: 'white'
    },
    bgColorLightness: {
      type: Number,
      default: 500
    },
    rounded: {
      type: Boolean
    },
    dismissBtnText: {
      type: String,
      default: 'Dismiss'
    },
    cookiePolicyBtn: {
      type: Boolean,
      default: true
    },
    cookiePolicyBtnText: {
      type: String,
      default: 'Policy'
    },
    zIndex: {
      type: Number,
      default: 2000
    }
  },
  methods: {
    dismiss () {
      this.$emit('dismiss', false)
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/cookie-consent/cookie-consent.vue